module.exports = __webpack_public_path__ + "images/chart05.png";